<body class="text-black dark:text-white">
  <app-modal-vehicle-edit *ngIf="showModal" [selectedVehicle]="selectedVehicle" (close)="showModal = false"> </app-modal-vehicle-edit>
  <div class="text-black dark:text-white">
    <div class="panel mt-6 pb-0 text-black dark:text-white">
      <div class="mb-5 flex flex-col gap-5 md:flex-row md:items-center text-black dark:text-white">
        <h5 class="text-lg font-semibold text-black dark:text-white">Registro de Vehículos <app-add-vehicle></app-add-vehicle></h5>
        <div class="ltr:ml-auto rtl:mr-auto text-black dark:text-white">
          <input [(ngModel)]="search" type="text" class="form-input pr-36 w-auto border border-primary text-primary" placeholder="Buscar..." />
        </div>
      </div>

      <div class="datatable">
        <ng-datatable
          [rows]="rows"
          [columns]="columns"
          [sortable]="true"
          sortColumn="marca"
          [search]="search"
          skin="whitespace-nowrap table-hover"
          firstArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
                      <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>'
          lastArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
                      <path d="M11 19L17 12L11 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>'
          previousArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
                           <path d="M15 5L9 12L15 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                         </svg>'
          nextArrow='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5">
                       <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                     </svg>'
        >
          <ng-template slot="action" let-value="data">
            <div class="flex items-center justify-center">
              <button type="button" class="ltr:mr-2 rtl:ml-2 text-primary" ngxTippy="Editar" (click)="openEditModal(value)">
                <icon-pencil></icon-pencil>
              </button>
              <button type="button" class="ltr:mr-2 rtl:ml-2 text-primary" ngxTippy="Eliminar" (click)="onDelete(value)">
                <icon-trash-lines></icon-trash-lines>
              </button>
            </div>
          </ng-template>

          <ng-template slot="status" let-value="data">
            <div class="flex items-center justify-center">
              <p>
                <button (click)="toggleStatus(value)" class="btn btn-sm" [ngClass]="value.status ? 'btn-danger' : 'btn-success'">
                  {{ value.status ? 'Deshabilitar' : 'Habilitar' }}
                </button>
              </p>
            </div>
          </ng-template>
        </ng-datatable>
      </div>
    </div>
  </div>
</body>
